import { PlanningTransferApi, QCInspectionApi, PdpaApi, IBNonIBApi } from '@/api'
import { ConvertFormatDateToDDMMYY } from '@/utils/common'

export const SetSearchRequest = (jsonData: PlanningTransferApi.ISearchPlanningTransferRequest) => {
    return {
        projectId:                  jsonData.projectId,
        paymentMethodsId:           jsonData.paymentMethodsId === "" ? "0" : `${jsonData.paymentMethodsId}`,
        unitSelectType:             jsonData.unitSelectType,
        unitFrom:                   jsonData.unitFrom,
        unitTo:                     jsonData.unitTo,
        unitSelected:               jsonData.unitSelected,
        bookingDateTo:              jsonData.bookingDateTo,
        bookingDateFrom:            jsonData.bookingDateFrom,
        contractDateFrom:           jsonData.contractDateFrom,
        contractDateTo:             jsonData.contractDateTo,
        contractTransferDateFrom:   jsonData.contractTransferDateFrom,
        contractTransferDateTo:     jsonData.contractTransferDateTo,
        finalTransferDateFrom:      jsonData.finalTransferDateFrom.replace(/-/g, ''),
        finalTransferDateTo:        jsonData.finalTransferDateTo.replace(/-/g, ''),
        crPlanDateFrom:             jsonData.crPlanDateFrom,
        crPlanDateTo:               jsonData.crPlanDateTo,
        transferPlanDateFrom:       jsonData.transferPlanDateFrom,
        transferPlanDateTo:         jsonData.transferPlanDateTo,
        transferStatusId:           `${jsonData.transferStatusId}`,
        recieceStatus:              jsonData.recieceStatus,
        statusSold:                 jsonData.statusSold,
        crId:                       `${jsonData.crId}`, 
        salesId:                    jsonData.salesId,
        nationalityType:            jsonData.nationalityType,
        addressNoText:              jsonData.addressNoText,
    }
}

export const SetJsonSearchRefresh = (projectId: string, unitSelected: string[]): any => {
    return {
        projectId:                  projectId,
        paymentMethodsId:           "0",
        unitSelectType:             "unitSelected",
        unitFrom:                   "",
        unitTo:                     "",
        unitSelected:               unitSelected,
        bookingDateTo:              "",
        bookingDateFrom:            "",
        contractDateFrom:           "",
        contractDateTo:             "",
        contractTransferDateFrom:   "",
        contractTransferDateTo:     "",
        finalTransferDateFrom:      "",
        finalTransferDateTo:        "",
        crPlanDateFrom:             "",
        crPlanDateTo:               "",
        transferPlanDateFrom:       "",
        transferPlanDateTo:         "",
        transferStatusId:           "",
        recieceStatus:              "",
        statusSold:                 ["Sold", "Unsold"],
        crId:                       "",
        salesId:                    "",
        nationalityType:            "",
    }
}


export const SetTableDataObject = (SearchPlanningTransferData: PlanningTransferApi.ISearchPlanningTransferResponse[]) => {
    let newDataTable = SearchPlanningTransferData.map((data: PlanningTransferApi.ISearchPlanningTransferResponse) => {
        let newObject: IDataTableTransferPlanning = {
            unitId: data.unitId,
            unitCode: data.unitCode,
            bookingId: data.bookingId,
            sapContractNo: data.sapContractNo,
            signId: data.signId,
            activeSign: data.activeSign,
            transferId: data.transferId,
            prospectId: data.prospectId,
            landArea: data.landArea,
            usageArea: data.usageArea,
            landSize: data.landSize,
            usageSize: data.usageSize,
            addressNo: data.addressNo,
            areaValue: data.areaValue,
            customerName: data.customerName,
            contractUnitPrice: data.contractUnitPrice.toLocaleString(),
            netPrice: data.netPrice.toLocaleString(),
            bookActivityDate: data.bookActivityDate,
            signActivityDate: data.signActivityDate,
            signActivityId: data.signActivityId,
            contractTransferDate: data.contractTransferDate,
            letterRequestExtendReduceTransferDate: data.letterRequestExtendReduceTransferDate,
            contactStatusId: data.contactStatusId,
            receivePromotionId: data.receivePromotionId,
            joinEventId: data.joinEventId,
            purposeOfBuyId: data.purposeOfBuyId,
            customerDepositStock: data.customerDepositStock,
            sendRoomStatus: data.sendRoomStatus,
            inspection1SendRoomDate: data.inspection1SendRoomDate,
            inspection1Id: data.inspection1Id,
            inspection1PlanPJDate: data.inspection1PlanPJDate,
            inspection1AppointmentStatusId: data.inspection1AppointmentStatusId,
            inspection1TypeId: data.inspection1TypeId,
            inspection1TypeText: data.inspection1TypeText,
            inspection1PlanCRDate: ConvertFormatDateToDDMMYY(data.inspection1PlanCRDate),
            inspection1PlanCRTime: data.inspection1PlanCRTime,
            inspection1PlanCRDateEdit: ConvertFormatDateToDDMMYY(data.inspection1PlanCRDate),
            inspection2SendRoomDate: data.inspection2SendRoomDate,
            inspection2Id: data.inspection2Id,
            inspection2PlanPJDate: data.inspection2PlanPJDate,
            inspection2AppointmentStatusId: data.inspection2AppointmentStatusId,
            inspection2TypeId: data.inspection2TypeId,
            inspection2TypeText: data.inspection2TypeText,
            inspection2PlanCRDate: ConvertFormatDateToDDMMYY(data.inspection2PlanCRDate),
            inspection2PlanCRTime: data.inspection2PlanCRTime,
            inspection2PlanCRDateEdit: ConvertFormatDateToDDMMYY(data.inspection2PlanCRDate),
            inspection3SendRoomDate: data.inspection3SendRoomDate,
            inspection3Id: data.inspection3Id,
            inspection3PlanPJDate: data.inspection3PlanPJDate,
            inspection3AppointmentStatusId: data.inspection3AppointmentStatusId,
            inspection3TypeId: data.inspection3TypeId,
            inspection3TypeText: data.inspection3TypeText,
            inspection3PlanCRDate: ConvertFormatDateToDDMMYY(data.inspection3PlanCRDate),
            inspection3PlanCRTime: data.inspection3PlanCRTime,
            inspection3PlanCRDateEdit: ConvertFormatDateToDDMMYY(data.inspection3PlanCRDate),
            inspection4SendRoomDate: data.inspection4SendRoomDate,
            inspection4Id: data.inspection4Id,
            inspection4PlanPJDate: data.inspection4PlanPJDate,
            inspection4AppointmentStatusId: data.inspection4AppointmentStatusId,
            inspection4TypeId: data.inspection4TypeId,
            inspection4TypeText: data.inspection4TypeText,
            inspection4PlanCRDate: ConvertFormatDateToDDMMYY(data.inspection4PlanCRDate),
            inspection4PlanCRTime: data.inspection4PlanCRTime,
            inspection4PlanCRDateEdit: ConvertFormatDateToDDMMYY(data.inspection4PlanCRDate),
            vipStatus: data.vipStatus,
            saleStatus: data.saleStatus,
            model: data.model,
            mobilePhone: data.mobilePhone,
            country: [data.country, data.country2, data.country3, data.country4].filter(x => x != "").join(),
            email: data.email,
            paymentLast: data.paymentLast,
            inspectionNumLatest: data.inspectionNumLatest,
            inspectionSendRoomDateLatest: data.inspectionSendRoomDateLatest,
            inspectionAppointmentStatusLatest: data.inspectionAppointmentStatusLatest,
            inspectionPlanCRDateLatest: ConvertFormatDateToDDMMYY(data.inspectionPlanCRDateLatest),
            inspectionPlanCRTimeLatest: data.inspectionPlanCRTimeLatest,
            crComment: data.crComment,
            pjComment: data.pjComment,
            inspectionTypeTextLatest: data.inspectionTypeTextLatest,
            summaryRoomStatus: data.summaryRoomStatus,
            crPlan: ConvertFormatDateToDDMMYY(data.crPlan),
            transferPlanDate: ConvertFormatDateToDDMMYY(data.transferPlanDate),
            transferOutDateHistory: ConvertFormatDateToDDMMYY(data.transferOutDateHistory),
            transferDateReal: ConvertFormatDateToDDMMYY(data.transferDateReal),
            flagActiveTransfer: data.flagActiveTransfer,
            expectTranMonth: ExpectTranMonth(data),
            transferStatusId: data.transferStatusId,
            transferTypeId: data.transferTypeId,
            creditAppv: data.creditAppv,
            bankId: data.bankId,
            bankName: data.bankName,
            useBankReason: data.useBankReason,
            usedBankCount: data.usedBankCount,
            transferCRRemark: data.transferCRRemark,
            deedName1: data.deedName1,
            deedName2: data.deedName2,
            deedName3: data.deedName3,
            deedName4: data.deedName4,
            operationId: data.operationId,
            operationTime: data.operationTime,
            mortgageValue: data.mortgageValue.replace(".00", "") == "" ? "0": parseInt(data.mortgageValue.replace(".00", "")).toLocaleString(),
            mortgageCompValue: data.mortgageCompValue.replace(".00", "") == "" ? "0": parseInt(data.mortgageCompValue.replace(".00", "")).toLocaleString(),
            lettTransRemark: data.lettTransRemark,
            transferPlanDateSp: ConvertFormatDateToDDMMYY(data.transferPlanDateSp),
            flagTransferLetter: ckFlagTransferLetter(data),
            transferLetterDate: ConvertFormatDateToDDMMYY(data.transferLetterDate),
            flagHaveAddress: data.flagHaveAddress,
            flagTransferOutLetter: ckFlagTransferOutLetter(data),
            transferOutLetterDate: data.transferOutLetterDate,
            flagTransferChangeLetter: ckFlagTransferChangeLetter(data),
            transferChangeLetterDate: data.transferChangeLetterDate,
            flagTransferAdjustLetter: ckFlagTransferAdjustLetter(data),
            transferAdjustLetterDate: data.transferAdjustLetterDate,
            flagTransferCancelLetter: ckFlagTransferCancelLetter(data),
            transferCancelLetterDate: data.transferCancelLetterDate,
            flagTransferOutCancelLetter: ckFlagTransferOutCancelLetter(data),
            transferOutCancelLetterDate: data.transferOutCancelLetterDate,
            inspectionLetter1: data.inspectionLetter1,
            inspectionLetter2: data.inspectionLetter2,
            receiveHCLetter: data.receiveHCLetter,
            transferPlanDateLetter1: data.transferPlanDateLetter1,
            transferOut1: data.transferOut1,
            transferPlanDateLetter2: data.transferPlanDateLetter2,
            transferOut2: data.transferOut2,
            payStatus100pc: data.payStatus100pc,
            payStatus100pcCusOverPay: data.payStatus100pcCusOverPay,
            reasonStatus100pc: data.reasonStatus100pc,
            unitStatus: data.unitStatus,
            finalPlanDate: data.finalPlanDate,
            finalActualDate: data.finalActualDate,
            salesName: data.salesName,
            crId: data.crId,
            paymentMethod: data.paymentMethod,
            agentName: data.agentName,
            // Add
            useBankReasonOther: data.useBankReason,
            flagTransferLetterBefore: data.flagTransferLetter,
            transferLetterDateBefore: data.transferLetterDate,
            flagActiveTransferBefore: data.flagActiveTransfer,
            flagTransferAdjustLetterBefore: data.flagTransferAdjustLetter,
            transferPlanDateBefore: ConvertFormatDateToDDMMYY(data.transferPlanDate),
            transferPlanDateSpBefore: ConvertFormatDateToDDMMYY(data.transferPlanDateSp),
            qcInspection: "",
            qcStatus: "",
            signProspectId1: data.signProspectId1,
            signProspectId2: data.signProspectId2,    
            signProspectId3: data.signProspectId3,    
            signProspectId4: data.signProspectId4,    
            fullNameTH1: data.fullNameTH1,    
            fullNameEN1: data.fullNameEN1,    
            fullNameTH2: data.fullNameTH2,    
            fullNameEN2: data.fullNameEN2,    
            fullNameTH3: data.fullNameTH3,    
            fullNameEN3: data.fullNameEN3,    
            fullNameTH4: data.fullNameTH4,    
            fullNameEN4: data.fullNameEN4,    
            nationalityId: data.nationalityId,
            flagInspectorContractor: data.flagInspectorContractor,  
            inspectorName: data.flagInspectorContractor ? data.inspectorName : "",
            transferUpdatedDate: data.transferUpdatedDate,
            bankCreditStatus: data.bankCreditStatus
        }
        return newObject
    })
    return newDataTable
}

export const AddQCInspection = async (planningTransferData: IDataTableTransferPlanning[], unitSelectType: string) => {
    try {
        let requestObject = {}
        let unitCodeQcInspection = [] as QCInspectionApi.IGetQCInspection[]
        const projectCode = planningTransferData[0].unitCode.split('-')[0].trim() ?? ''
        if (unitSelectType === 'unitAll') {
            requestObject = { ProjectCode: projectCode, UnitCode: []}
            unitCodeQcInspection = await QCInspectionApi.GetQCInspection(requestObject) 
        } else {
            unitCodeQcInspection = await QCInspectionApi.GetQCInspection({ projectCode, UnitCode: planningTransferData.map(p => (p.unitCode.trim())) }) 
        }
        planningTransferData.map(p => {
            let qc = unitCodeQcInspection.filter(q => q.unitCode == p.unitCode)
            p.qcInspection = qc.length > 0 ? qc[0].qcInspection : ""
            p.qcStatus = qc.length > 0 ? qc[0].qcStatus : ""
            return p
        })
        return { 
            status: "OK",
            planningTransferData: planningTransferData
        }
    } catch {
        return { 
            status: "ERROR",
            planningTransferData: []
        }
    }
}

export const AddPDPA = async (planningTransferData: IDataTableTransferPlanning[]) => {
    try {

        let prospectId1 = planningTransferData.filter(p => p.signProspectId1 != "0").map(p => (p.signProspectId1))
        let prospectId2 = planningTransferData.filter(p => p.signProspectId2 != "0").map(p => (p.signProspectId2))
        let prospectId3 = planningTransferData.filter(p => p.signProspectId3 != "0").map(p => (p.signProspectId3))
        let prospectId4 = planningTransferData.filter(p => p.signProspectId4 != "0").map(p => (p.signProspectId4))
        let prospectIds = [...prospectId1, ...prospectId2, ...prospectId3, ...prospectId4]

        const pdpaConsent: PdpaApi.IPdpaData = await PdpaApi.GetPdpaByProspectId(prospectIds)
        const collectionIds = pdpaConsent.collection.map(c => c.id)
        const identifierLists = pdpaConsent.identifierLists
        
        planningTransferData.map((p: any) => {
            p[`pdpaConsent1`] = ''
            p[`pdpaConsent2`] = ''
            p[`pdpaConsent3`] = ''

            let pdpa = identifierLists.filter(i =>  i.identifier == `SF_${p.signProspectId1}` ||  
                                                    i.identifier == `SF_${p.signProspectId2}` || 
                                                    i.identifier == `SF_${p.signProspectId3}` ||  
                                                    i.identifier == `SF_${p.signProspectId4}`)
            p[`pdpa`] = pdpa

            return p
        })


        return { 
            status: "OK",
            collectionIds: pdpaConsent.collection,
            planningTransferData: planningTransferData
        }
    } catch {
        return { 
            status: "ERROR",
            collectionIds: [],
            planningTransferData: []
        }
    }
}

export const AddIBNonIB = async (projectId: number, planningTransferData: IDataTableTransferPlanning[]) => {
    try {
        const clonePlanningTransferData: IDataTableTransferPlanning[] = planningTransferData
        const objectRequest = clonePlanningTransferData.map(x => {
            return {
                projectId: Number(projectId),
                bookingId: Number(x.bookingId),
                nationalityLists: [
                                    x.country, 
                                    x.country2, 
                                    x.country3,
                                    x.country4
                                ].filter(x => x !== undefined)
            }
        })

        const ibNonIbLists: IBNonIBApi.IGetIBNonIB[] = await IBNonIBApi.GetIBNonIB(objectRequest)
        console.log('ibNonIbLists', ibNonIbLists)
        planningTransferData.map(p => {
            console.log(` ===> ${p.bookingId}`)
            const ibNonIb = ibNonIbLists.filter(x => x.bookingId == `${p.bookingId}`)
            console.log('ibNonIb ==> ', ibNonIb[0])
            p[`ibNonIb`] = ibNonIb.length > 0 ? ibNonIb[0].status : ""
            return p
        })

        return { 
            status: "OK",
            planningTransferData: planningTransferData
        }
    } catch {
        return { 
            status: "ERROR",
            planningTransferData: []
        }
    }
}


const ExpectTranMonth = (x: PlanningTransferApi.ISearchPlanningTransferResponse) => {
    if (x.transferDateReal !== "" && x.flagActiveTransfer === true) 
        return ConvertFormatDateToDDMMYY(x.transferDateReal)
    if (x.expectTranMonth !== "") 
        return `${x.expectTranMonth.split('-')[1]}-${x.expectTranMonth.split('-')[0]}`
    return ""
}

// ส่งเมลผิดนัดการโอน
// ไม่ต้อง set ค่าเพราะ ส่งกี่ครั้งก็ได้
const ckFlagTransferOutLetter = (item: PlanningTransferApi.ISearchPlanningTransferResponse) => {
    if (item.flagTransferOutLetter === false) {
        if (item.transferOutLetterDate != "") return true

        return false
    }
    return true
}
// ส่งเมลเปลี่ยนแปลงการโอน
// ไม่ต้อง set ค่าเพราะ ส่งกี่ครั้งก็ได้
// ถ้าไม่มีการส่งนัดโอน ปิดไม่ให้ติ๊กส่งอีเมล เปลี่ยนแปลงการโอน
const ckFlagTransferChangeLetter = (item: PlanningTransferApi.ISearchPlanningTransferResponse) => {
    if (item.flagTransferChangeLetter === false) {
        if (item.transferChangeLetterDate != "") return true

        return false
    } 
    return true
}
// ส่งเมลเลื่อนการโอน
// ไม่ต้อง set ค่าเพราะ ส่งกี่ครั้งก็ได้
// ถ้าไม่มีการส่งนัดโอน ปิดไม่ให้ติ๊กส่งอีเมล เลื่อนโอน
const ckFlagTransferAdjustLetter = (item: PlanningTransferApi.ISearchPlanningTransferResponse) => {
    if (item.flagTransferAdjustLetter === false) {
        if (item.transferAdjustLetterDate != "") return true

        return false
    }
    return true
}
// ส่งเมลยกเลิกการโอน
// ถ้าไม่มีการส่งนัดโอน ปิดไม่ให้ติ๊กส่งอีเมล ยกเลิกโอน
const ckFlagTransferCancelLetter = (item: PlanningTransferApi.ISearchPlanningTransferResponse) => {
    if (item.flagTransferCancelLetter === false) {
        if (item.transferCancelLetterDate != "") return true

        return false
    }
    return true
}
// ส่งเมลยกเลิกผิดนัดโอน
// ถ้าไม่มีการส่งผิดนัดโอน ปิดไม่ให้ติ๊กส่งอีเมล ยกเลิกผิดนัดโอน
// เช็คว่ามีประวัติวันที่ผิดนัดโอนรึเปล่า  เพราะ flag ติ๊ก ส่งผิดนัดโอน จะถูก clear เป็น 0 เสมอ
const ckFlagTransferOutCancelLetter = (item: PlanningTransferApi.ISearchPlanningTransferResponse) => {
    if (item.flagTransferOutCancelLetter === false) {
        if (item.transferOutCancelLetterDate != "") return true

        return false
    }
    return true
}
// ส่งเมลข้อมูลการโอน
// ถ้าเคยส่งอีเมลไปแล้ว ให้ Edit ไม่ได้
// ไม่เคยส่งอีเมล และ saveไว้ว่าจะส่ง(ดูจากมีวันที่ส่งอีเมลมีค่า และ flag ส่งเป็น 0) ก็ให้ ติ๊ก chk ทิ้งไว้
const ckFlagTransferLetter = (item: any) => {
    if (item.flagTransferLetter === true) return true
    if (item.transferLetterDate != "" && item.flagTransferLetter === false) return true
    return false
}

export interface IDataTableTransferPlanning extends Omit<PlanningTransferApi.ISearchPlanningTransferResponse, 'contractUnitPrice' | 'netPrice'> {
    flagTransferLetterBefore: boolean
    flagActiveTransferBefore: boolean
    transferLetterDateBefore: string
    transferPlanDateBefore: string
    transferPlanDateSpBefore: string
    contractUnitPrice: string
    netPrice: string
    useBankReasonOther: string
    qcInspection: string
    qcStatus: string
    ibNonIb?: string
}
